import { render, staticRenderFns } from "./ListInvoices.vue?vue&type=template&id=bb772fe4&"
import script from "./ListInvoices.vue?vue&type=script&lang=js&"
export * from "./ListInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ListInvoices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports